<template>
  <div class="content" ref="body"  v-if="!isH5" >
    <div class="header-body">
      <div class="logo" @click="goHome()">
        <img src="@/assets/image/logo_white.png" alt="" srcset="" >
        <!-- <img src="@/assets/image/logo_black.png" alt="" srcset="" v-else> -->
      </div>
      <div class="list" :style="scrollTop ? 'color:white' : 'color:white'" style="display: flex;">
        <navbar :navItems="title" :navStyle="scrollTop == 0 ? true : true" :openSearch="openSearch" :closeSearch="closeSearch"></navbar>
      </div>
      <!-- 添加语言切换组件 -->
      <div class="language-section">
        <LanguageSwitcher 
          :refreshOnChange="true" 
          @language-changed="onLanguageChanged"
          @refresh-requests="refreshPageData"
        />
      </div>
      <div class="login">
        <template v-if="isLogin">
          <el-dropdown class="avatar-container right-menu-item hover-effect" trigger="click">
            <div class="avatar-wrapper">
              <div style="display: flex; flex-direction: column; width: 40px;">
                <img :src="avatar" class="user-avatar" style="width: 100%;" onerror="this.onerror=null; this.src='@/assets/image/webdefault.png'">
                <p style="margin: 0; line-height: 28px; color: white; 
                          white-space: nowrap; 
                          min-width: 0; 
                          overflow: visible;">
                  {{ watchName }}
                </p>
              </div>
              <i class="el-icon-caret-bottom" />
            </div>
            <el-dropdown-menu slot="dropdown" placement="bottom">
              <el-dropdown-item @click.native="goToPersonalCenter">{{ $t('login.personal') }}</el-dropdown-item>
              <el-dropdown-item divided @click.native="logout">
                <span>{{ $t('login.logout') }}</span>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </template>
        <template v-else>
          <span class="logo-title" @click="login()">{{ $t('login.loging') }}</span>
        </template>
        <!-- <personal @closePersonal="closePersonal" v-show="personalShow"></personal> -->
      </div>
    </div>
    
  </div>
  <div class="content" ref="body" :class="scrollTop ? 'white-bg' : ''" v-else>
    <div class="header-body">
      <div class="logo" @click="goHome()">
        <img src="@/assets/image/logo_white.png" alt="" srcset="" >
        <!-- <img src="@/assets/image/logo_black.png" alt="" srcset="" v-else> -->
      </div>
      <div class="list" :style="scrollTop ? 'color:black' : ''">
        <i class="el-icon-s-fold" @click="openDraw" ></i>
      </div>
      <div class="search">
        <i class="el-icon-search"   @click="openSearch"></i>
      </div>
      <!-- 移动端语言切换 -->
      <div class="language-section-mobile">
        <LanguageSwitcher 
          :is-compact="true"
          :refreshOnChange="true" 
          @language-changed="onLanguageChanged"
          @refresh-requests="refreshPageData"
        />
      </div>
      <div class="login-mobile">
        <template v-if="isLogin">
          <el-dropdown class="avatar-container right-menu-item hover-effect" trigger="click">
            <div class="avatar-wrapper">
              <div style="display: flex; flex-direction: column; width: 26px;">
                <img :src="avatar" class="user-avatar" style="width: 100%;" onerror="this.onerror=null; this.src='@/assets/image/webdefault.png'">
                <!-- <p style="margin: 0; line-height: 28px; color: white; 
                          white-space: nowrap; 
                          min-width: 0; 
                          overflow: visible;">
                  {{ watchName }}
                </p> -->
              </div>
              <i class="el-icon-caret-bottom" />
            </div>
            <el-dropdown-menu slot="dropdown" placement="bottom">
              <el-dropdown-item @click.native="goToPersonalCenter">{{ $t('login.personal') }}</el-dropdown-item>
              <el-dropdown-item divided @click.native="logout">
                <span>{{ $t('login.logout') }}</span>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </template>
        <template v-else>
          <span class="logo-title" @click="login()">{{ $t('login.loging') }}</span>
        </template>
        <!-- <personal @closePersonal="closePersonal" v-show="personalShow"></personal> -->
      </div>
      <el-drawer
        :visible.sync="drawer"
        size="70%"
        append-to-body
        >
        <navbar @closeFun="handleClose" :navItems="title" :navStyle="scrollTop == 0 ? true : false" :openSearch="openSearch" :closeSearch="closeSearch"></navbar>
      </el-drawer>
    </div>
    <div class="search-body" v-show="searchShow">
      <Search @closeSearch="closeSearch"></Search>
    </div>
  </div>
</template>

<script>
import navbar from '@/components/navbar'
import Search from '@/components/search'
import LanguageSwitcher from '@/components/LanguageSwitcher'
import { listenEvent } from '@/utils/eventBus'
import i18nMonitorMixin from '@/mixins/i18n-monitor-mixin'; // 引入路由和语言功能
import pageRefreshMixin from '@/mixins/page-refresh-mixin'; // 引入页面刷新功能

export default {
  name: 'Myheader',
  mixins: [i18nMonitorMixin, pageRefreshMixin], // 使用混入获得统一的路由、语言和刷新功能
  components: {
    navbar, Search, LanguageSwitcher
  },
  data() {
    return {
      screenWidth: document.body.clientWidth,
      title: [],
      scrollTop: 0,
      isH5:false,
      drawer:false,
      searchShow:false,
      isLogin:this.$store.state.user.token?true:false,
      avatar:'',
      personalShow:false,
      watchName:this.$store.state.user.nickname,
      baseUrl:process.env.VUE_APP_BASE_API,
      defaultAvatar:require('@/assets/images/default.png'),
    }
  },
  watch: {
    screenWidth(newVal) {
      if(newVal <= 1024){
        this.isH5=true;
        window.localStorage.setItem('isH5',true)
      }else{
        this.isH5=false;
        window.localStorage.setItem('isH5',false)
      }
      // this.boxWscreenWidthidth = document.body.clientWidth;
    },
    watchToken(newVal, oldVal) {
      if(newVal){
        this.isLogin=true;
      }
    },
    '$store.state.user.nickname'(newVal) {
      this.watchName = newVal;
    },
    '$store.state.user.avatar'(newVal) {
      this.getAvatar();
    },
    '$i18n.locale'(){
      this.updateTitles();
    }
  },
  computed: {
    watchToken() {
      return this.$store.state.user.token
    },
  },
  created() {
    listenEvent('logout-message',(()=>{this.isLogin=false;}));
  },
  async  mounted() {
    this.updateTitles();
    // window.addEventListener('scroll', this.handleScroll);
    const that = this;
    this.isH5=JSON.parse(window.localStorage.getItem('isH5'))
    window.addEventListener("resize", () => { 
        window.screenWidth = document.body.clientWidth;
        that.screenWidth = window.screenWidth;
    });
    if(this.$store.state.user.token){
      await this.$store.dispatch('user/GetInfo')
      this.getAvatar();
    }
  },
  methods: {
    openSearch(){
      this.searchShow=true;
    }, 
    closeSearch(){
      this.searchShow=false;
    },
      // 统一的数据刷新方法
    async refreshData() {
      try {
        
        // 更新导航标题
        this.updateTitles()
        
        // 如果用户已登录，刷新用户信息
        if (this.$store.state.user.token) {
          await this.$store.dispatch('user/GetInfo')
          this.getAvatar()
        }
        
      } catch (error) {
        console.error('❌ Failed to refresh header data:', error)
      }
    },
    updateTitles(){
      // 获取当前语言
      const currentLang = this.$store.state.user.lang || 'en';
      
      this.title = [
        { name: this.$t('message.language_153'), url: `/${currentLang}/` },
        { name: this.$t('message.language_1'), url: `/${currentLang}/products?title=${this.$t('settings.language_2')}` }, 
        { name: this.$t('message.language_2'), url: `/${currentLang}/project` }, 
        { name: this.$t('message.language_3'), url: `/${currentLang}/downloads` }, 
        { name: this.$t('message.language_4'), url: `/${currentLang}/custom` },
        { name: this.$t('message.language_5'), url: `/${currentLang}/news`},
        { name: this.$t('message.language_0'), url: `/${currentLang}/videos` },  
        { name: this.$t('message.language_6'), url: `/${currentLang}/company` },
        { name: this.$t('message.language_7'), url: `/${currentLang}/contact` },
        { name: this.$t('search.language_4'), url: `/${currentLang}/` }
      ]
    },
    closePersonal(){
      this.personalShow=false;
    },
    goToPersonalCenter() {
      // 获取当前语言
      const currentLang = this.$store.state.user.lang || 'en';
      this.$router.push({ path: `/${currentLang}/personalCenter` });
    },
    async login(){
      await this.$login.show({
        onSuccess: async () => {
          await this.$store.dispatch('user/GetInfo')
        }
      });
      let isSuccess=await this.$login.isSuccess;
    },
    getAvatar(){
      const avatarPath = this.$store.state.user.avatar;

      if (avatarPath && avatarPath.trim() !== '') {
          const isBase64 = avatarPath.startsWith('data:image/');
          this.avatar = isBase64 ? avatarPath : this.baseUrl + avatarPath;
      } else {
          // 使用 require 来获取静态资源的正确路径
          // Webpack 会将其转换为类似 "/img/avatar.8e8c8c8.png" 的 URL
          this.avatar = this.defaultAvatar;
      }
    },
    async logout(){
      await this.$store.dispatch('user/LogOut')
      this.$message({
        message: 'Logout success',
        type: 'success',
        offset: 200,
        customClass: 'messageBox'
      });
      this.isLogin=false;
      window.location.reload()
    },
    // selectLanguage(){
    //   this.$i18n.locale = this.language;
    //   this.$router.go(0)
    //   localStorage.setItem("locale", this.language.text); //保存本地
    //   localStorage.setItem("lang", this.language.code);
    // },
    openDraw(){
      this.drawer=true;
    },
    handleClose(){
      this.drawer=false;
    },
    // 处理语言切换事件
    onLanguageChanged(changeInfo) {
      
      // 更新导航标题
      this.updateTitles()
      
      // 触发全局事件
      this.$emit('language-changed', changeInfo)
    },
    // 刷新页面数据
    async refreshPageData() {
      try {
        // 刷新导航数据
        this.updateTitles()
        // 触发全局刷新事件
        if (this.$eventBus) {
          this.$eventBus.$emit('language-changed-refresh', {
            timestamp: Date.now(),
            source: 'myheader'
          })
        }
        
        // 如果有父组件的刷新方法，调用它
        if (this.$parent && typeof this.$parent.refreshData === 'function') {
          await this.$parent.refreshData()
        }
        
      } catch (error) {
        console.error('❌ Failed to refresh page data:', error)
      }
    },
    // 优化后的路由跳转方法（使用新的统一API）
    async goHome() {
      if (this.$route.path !== '/') {
        try {
          await this.$navigateTo('/');
        } catch (error) {
          console.error('Navigation to home failed:', error);
        }
      }
    },
    handleScroll() {
      let distance = this.$refs.body.offsetTop - window.pageYOffset;
      this.scrollTop = distance;
    }
  },
}
</script>

<style lang="less" scoped>
.select{
  width: 7.5rem;
  border: none;
  font-size: 1rem;
  color: white;
  background-color: black;
  padding: .5rem;
  border-radius: .5rem;
  option{
    background-color: #333333;
    color: white;
  }
}
.white {
  background-color: #fff;
  color: #000;
}
.content {
  width: 100%;
  position: fixed;
  top: 0;
  display: flex;
  z-index: 1001!important;
  background-color: black;

  .header-body {
    // width: 107.5rem;
    width: 100%;
    margin: 0 auto;
    display: flex;
    // justify-content: space-between;
    position: relative;
    .logo {
      margin-left: 12rem;
      cursor: pointer;
      @media screen and (max-width: 1463px){
        margin-left: 8rem;
      }
      @media screen and (min-width: 2560px){
        margin-left: calc(100% / 6 );
      }
      @media screen and (max-width: 2560px){
        margin-left: 12rem;
      }
      img {
        margin: 1rem 0;
        width: 8.6875rem;
        height: 2.6875rem;
        // 确保图片保持原始比例
        max-width: 100%;
        height: auto;
      }
    }
    @media screen and (max-width: 64rem) {
      padding: 1.5rem;
      justify-content: space-between;
      .logo {
        cursor: pointer;
        margin-left: 2rem;
        img{
          // 统一移动端logo大小，使用相对单位
          width: 96px;
          height: auto;
          max-width: 100%;
          margin: 0.5rem 0;
        }
      }
    }
    @media screen and (max-width: 768px){
      height: 50px;
      align-items: center;
      justify-content: space-between;
      .logo {
        cursor: pointer;
        img {
          // 统一小屏幕logo大小，使用固定宽度
          width: 72px;
          height: auto;
          margin: 0;
        }
      }
    }
    @media screen and (max-width: 480px){
      .logo {
        img {
          // 超小屏幕进一步优化
          width: 60px;
        }
      }
    }
  }
  .list {
    // margin-left: 15.75rem;
    margin-left: 5rem;
    // width: 1440px;
    width: 50%;
    color: white;
    z-index: 1999 !important;
    position: relative;
    @media screen and (max-width: 1280px){
      margin-left: 2.75rem;
    }
    @media screen and (min-width: 2560px){
      margin-left: 13.75rem;
    }
    @media screen and (max-width: 2560px){
      margin-left: 15rem;
    }
    @media screen and (max-width: 2048px){
      margin-left: 8rem;
    }
    @media screen and (max-width: 1463px){
      margin-left: 3rem;
    }
    .el-icon-s-fold{
      
      position: absolute;
      right: 0;
      top: 1.25rem;
      font-size: 6rem;
    }
    @media screen  and (max-width: 1024px){
      width: 9rem;
      .el-icon-s-fold{
      
        position: absolute;
        right: 1rem;
        top: 0.25rem;
        font-size:3rem;
     }
    }
    @media screen  and (max-width: 768px){
      .el-icon-s-fold{
      
        position: absolute;
        right: 0;
        top: -2.75rem;
        font-size: 6rem;
      }
    }
  }
  .login{
    width: 18.75rem;
    position: absolute;
    right: 0;
    height: 100%;
    line-height: 5rem;
    color: white;
    font-size: 1.5rem;
    background-color: #000;
    z-index: 10000;
    @media screen and (max-width: 1024px) {
      width: 12.5rem;
    }
    @media screen and (max-width: 1280px) {
      width: 12.5rem;
      font-size: 1.375rem;
      line-height: 5.25rem;
    }
    .logo-title{
      cursor: pointer;
      transition: transform 0.3s ease;
      display: inline-block;
      &:hover{
        text-decoration: underline;
        transform: scale(1.05);
      }
    }
    .avatar-container {
      margin-right: 30px;

      .avatar-wrapper {
        margin-top: 20px;
        position: relative;

        .user-avatar {
          cursor: pointer;
          width: 40px;
          height: 40px;
          border-radius: 50%;
          border: solid 1px #ccc;
          background-color: white;
        }

        .el-icon-caret-bottom {
          cursor: pointer;
          position: absolute;
          right: -20px;
          top: 25px;
          font-size: 12px;
        }
      }
    }
  }
  
  // 语言切换器样式
  .language-section {
    position: absolute;
    right: 16.75rem; // 位于登录区域左侧
    top: 50%;
    transform: translateY(-50%);
    z-index: 10001;
    
    @media screen and (max-width: 1280px) {
      right: 9.5rem;
    }
    
    @media screen and (max-width: 1024px) {
      right: 12.5rem;
    }
  }
  .search{
    position: absolute;
    right: 52rem;
    top: 37%;
    z-index: 10001;
    i{
      font-size: 16px;
      color: white;
    }
  }
  .language-section-mobile {
    position: absolute;
    right: 30rem; // 调整位置，避免与右侧图标重叠
    top: 50%;
    transform: translateY(-50%);
    z-index: 10001;
    
    @media screen and (max-width: 768px) {
      right: 27.5rem; // 在小屏幕上进一步调整
    }
  }
  .login-mobile{
    // width: 18.75rem;
    position: absolute;
    right: 14rem;
    height: 100%;
    line-height: 5rem;
    color: white;
    font-size: 1.5rem;
    // background-color: #000;
    z-index: 10000;
    @media screen and (max-width: 1024px) {
      width: 12.5rem;
    }
    @media screen and (max-width: 1280px) {
      width: 12.5rem;
      font-size: 3.375rem;
      line-height: 19.25rem;
    }
    .logo-title{
      cursor: pointer;
      transition: transform 0.3s ease;
      display: inline-block;
      &:hover{
        text-decoration: underline;
        transform: scale(1.05);
      }
    }
    .avatar-container {
      margin-right: 30px;

      .avatar-wrapper {
        margin-top: 20px;
        position: relative;

        .user-avatar {
          cursor: pointer;
          width: 24px;
          height: 24px;
          border-radius: 50%;
          border: solid 1px #ccc;
          background-color: white;
        }

        .el-icon-caret-bottom {
          cursor: pointer;
          position: absolute;
          right: -20px;
          top: 6px;
          font-size: 12px;
        }
      }
    }
  }
  .control-strip {
    flex: 1;
    align-content: center;  
  }
}
.search-body{
  width: 100%;
  height: 100vh;
  position: absolute;
  z-index:10002;
  left:0;
  top: 0;
}
/deep/ .el-input__inner {
  background-color: black;
  border: none;
  color: white;
  width: 6.25rem;
}

/deep/ .selected {
  color: red;
}

.options {
  background-color: black;
  color: white;
  border: none;

  &:hover {
    background-color: white;
    color: black;
  }
}

.white-bg {
  background-color: white;
  color: black;
}
</style>
